export const GAME_ID = {
  RANDOM_VALUE: 'random_value',
  RANDOM_MULTIPLIER: 'random_multiplier'
}

export const SCRATCH_CARD_VALUE = 25

export const SCRATCH_GAME_STATUS = {
  INIT: 0,
  SCRATCHING: 1,
  REVEAL: 2,
  CONFIRMATION: 3
}
